import React, { useState } from "react";
import { useSelector } from "react-redux";
import Avatar from "./Avatar";
import { useTranslation } from "react-i18next";

const InputComment = ({ postId, handleSubmittingComment }) => {
  const [comment, setComment] = useState("");
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { t } = useTranslation("communityFeed");
  const hasComment = comment.trim().length > 0;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && hasComment) {
      handleSubmittingComment({ postId, comment, setComment });
    }
  };

  return (
    <div className="input-comment">
      <Avatar
        height="40"
        width="40"
        avatarUrl={currentUser?.admin?.avatar_url ?? currentUser?.avatar_url}
      />
      <input
        type="text"
        placeholder={t("communityFeed:addComment")}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button
        className={`ms-auto input-comment__send${
          hasComment ? " input-comment__send--active" : ""
        }`}
        type="button"
        disabled={!hasComment}
        onClick={() =>
          handleSubmittingComment({ postId, comment, setComment })
        }
      >
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="20"
          viewBox="0 0 22 20"
          aria-hidden="true"
        >
          <path
            d="M22.417,23.415,2.687,14.6a1.2,1.2,0,0,1,0-2.169l19.73-8.816a1.127,1.127,0,0,1,1.572,1.072L24,10.121a1.156,1.156,0,0,1-.984,1.167L7.04,13.515l15.976,2.216A1.177,1.177,0,0,1,24,16.909l-.011,5.433A1.127,1.127,0,0,1,22.417,23.415Z"
            transform="translate(-2 -3.515)"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  );
};

export default InputComment;
